"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core/");
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      margin: '1em 0',
      display: 'flex',
      flexDirection: 'column'
    },
    link: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.primary.main,
      padding: '.5em'
    },
    active: {
      color: "".concat(theme.palette.common.black, " !important"),
      padding: '.5em'
    },
    divider: {
      border: '1px solid lightgray',
      width: '100%'
    },
    secondContainer: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 600,
      marginTop: '5px',
      marginBottom: '5px',
      display: 'flex',
      padding: '0 .5em'
    },
    dash: {
      color: 'lightgray',
      margin: '0.3em 0'
    }
  };
});
var NavigationalModelEditConfig = {
  emptyLabel: 'Navigational Model',
  isEmpty: function isEmpty(props) {
    return true;
  }
};
var RecursiveNavRow = function RecursiveNavRow(_ref) {
  var _item$children, _item$children2;
  var item = _ref.item,
    currentPage = _ref.currentPage,
    children = _ref.children,
    _ref$depth = _ref.depth,
    depth = _ref$depth === void 0 ? 1 : _ref$depth,
    _ref$isParentSublink = _ref.isParentSublink,
    isParentSublink = _ref$isParentSublink === void 0 ? false : _ref$isParentSublink,
    setCurrentPage = _ref.setCurrentPage,
    key = _ref.key,
    activePage = _ref.activePage;
  var classes = useStyles();
  var childrensHaveCurrent = false;
  (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map(function (sublink, index) {
    if (JSON.stringify(item).indexOf('"' + currentPage + '"') > -1) {
      childrensHaveCurrent = true;
    }
    return sublink;
  });
  return __jsx(_react.default.Fragment, null, __jsx("div", {
    className: classes.secondContainer
  }, __jsx(_Remove.default, {
    className: classes.dash
  }), __jsx(_core.Link, {
    className: item.url !== currentPage ? classes.link : classes.active,
    href: item.url
  }, __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: item.title
    }
  }))), (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.map(function (sublink) {
    var key = 'row' + Math.floor(Math.random() * 1000);
    if (item.url === currentPage || childrensHaveCurrent) {
      return __jsx(_core.Box, {
        style: {
          marginLeft: 25 * depth + 'px',
          paddingTop: '0'
        }
      }, __jsx(RecursiveNavRow, {
        key: key,
        setCurrentPage: setCurrentPage,
        isParentSublink: item.url === currentPage,
        item: sublink,
        currentPage: currentPage,
        depth: depth + 1,
        activePage: activePage
      }, __jsx("span", {
        dangerouslySetInnerHTML: {
          __html: sublink.title
        }
      })));
    } else return null;
  }));
};
var NavigationalModel = function NavigationalModel(_ref2) {
  var _items;
  var items = _ref2.items,
    activePage = _ref2.activePage;
  var classes = useStyles();
  var _useState = (0, _react.useState)(activePage),
    currentPage = _useState[0],
    setCurrentPage = _useState[1];
  items = items.map(function (item, index) {
    var _item$children3;
    var childrensHaveCurrent = false;
    (_item$children3 = item.children) === null || _item$children3 === void 0 ? void 0 : _item$children3.map(function (sublink, index) {
      if (JSON.stringify(item).indexOf(currentPage) > -1) {
        childrensHaveCurrent = true;
      }
      return sublink;
    });
    item.hasCurrent = childrensHaveCurrent;
    return item;
  });
  return __jsx("div", {
    className: "aem-ms-navgational-model-cmp ".concat(classes.container)
  }, __jsx("hr", {
    className: classes.divider
  }), (_items = items) === null || _items === void 0 ? void 0 : _items.map(function (item) {
    var _item$children4;
    item.currentSelected = false;
    return __jsx(_react.default.Fragment, null, item.url !== currentPage && __jsx(_core.Link, {
      className: item.url !== currentPage ? classes.link : classes.active,
      href: item.url
    }, __jsx("span", {
      dangerouslySetInnerHTML: {
        __html: item.title
      }
    })), item.url === currentPage && __jsx("span", {
      className: classes.secondContainer,
      dangerouslySetInnerHTML: {
        __html: item.title
      }
    }), (_item$children4 = item.children) === null || _item$children4 === void 0 ? void 0 : _item$children4.map(function (sublink) {
      var key = 'row' + Math.floor(Math.random() * 1000);
      if (item.url === currentPage || item.hasCurrent) {
        return __jsx(RecursiveNavRow, {
          key: key,
          item: sublink,
          currentPage: currentPage,
          isParentSublink: item.url === currentPage,
          setCurrentPage: setCurrentPage,
          activePage: activePage
        }, sublink.title);
      } else {
        return null;
      }
    }), __jsx("hr", {
      className: classes.divider
    }));
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/leftnavigation')(NavigationalModel, NavigationalModelEditConfig);
exports.default = _default;